
<main class="page-main">
  <div class="container layout layout--docs">
    <div class="layout__row">
      <app-doc-side-nav [documentId]="DocumentId.TermsOfBusiness"></app-doc-side-nav>

      <div class="layout__bodycol" id="search-body">
        @for (header of getDocumentSection('header'); track header) {
          @if (header?.html?.includes('header')) {
            <div [innerHtml]="header?.html"></div>
          }
        }

        <section class="docs-content docs-content--wording docs-content--first" id="docs-overview">
          @for (list of arrDistinctList; track list) {
            @for (item of getDocumentSection(list); track item) {
              <div [innerHtml]="item?.html"></div>
            }
          }
        </section>
      </div>
    </div>
  </div>
</main>

<div class="policy-tray">
  <div class="policy-tray__details">
    <div class="container">
      <a href="#mobile-details" data-toggle="modal" class="button-control">
        <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
        <strong>More documents</strong>
      </a>
    </div>
  </div>
</div>

<!-- <footer class="docs-footer">
<div class="docs-footer__inner container">
  <img id="logo" src="./Broker appointment letter_files/logo(1).svg" alt="Everything.Insure">
  <p><strong>Questions?</strong> Contact Everything.Insure at<br>
  &lt;<a href="mailto:support@everything.insure">support@everything.insure</a>&gt; or call <strong>+27 (0)87 095 2823</strong></p>
</div>
</footer> -->




